import axiosClient from '@/api/axios';
import {IFlightItem} from '@/types/flight';
import {transformAirline} from '@/utils/flight';
import axios from 'axios';

export const getFlightId = async (item: IFlightItem) => {
  // remove all non-numeric characters
  // const number = item.flight_number.replace(/\D/g, '');
  // const flightNumber = `${item.airline}${number}`;
  // const url = `https://cors.node.np-platform.com/www.flightaware.com/live/flight/${flightNumber}`;
  // const html = await fetch(url).then((res) => res.text());
  // const match = html.match(/"flightId":"([A-Za-z0-9\-:]+)","takeoffTimes/);
  // if (match) {
  //   const text = match[1];
  //   // find index of first " and cut from start to that index
  //   const index = text.indexOf('"');
  //   console.log(index);
  //   return text.substring(0, index);
  // }
  // return null;
  const url = `/ATLAS_get_flight_info`;
  const {data} = await axiosClient.post(url, {
    flight_number: item.flight_number
  });
  if (data?.fa_flight_id) {
    return data.fa_flight_id;
  }
  return null;
};

export const getTracks = async (flightId: string) => {
  const url = `https://cors.node.np-platform.com/https://aeroapi.flightaware.com/aeroapi/flights/${flightId}/track`;
  const flightAwareKey = localStorage.getItem('FLIGHTAWARE_API_KEY');
  if (!flightAwareKey) return;
  const {data} = await axios.get(url, {
    headers: {
      'x-apikey': flightAwareKey
    }
  });
  return data;
};

export const getAllFlightOfAirline = async (airline: string) => {
  const url = `https://cors.node.np-platform.com/https://aeroapi.flightaware.com/aeroapi/flights/search?query=-airline "${transformAirline(
    airline
  )}"&max_pages=99`;
  const flightAwareKey = localStorage.getItem('FLIGHTAWARE_API_KEY');
  if (!flightAwareKey) return;
  const {data} = await axios.get(url, {
    headers: {
      'x-apikey': flightAwareKey
    }
  });
  return data?.flights;
};

export const getPreviousFlightOfRegistration = async (registration: string) => {
  const url = `https://cors.node.np-platform.com/https://aeroapi.flightaware.com/aeroapi/flights/search?query={ident_or_reg {${registration.replace(
    '-',
    '*'
  )}}}`;
  const flightAwareKey = localStorage.getItem('FLIGHTAWARE_API_KEY');
  if (!flightAwareKey) return;
  const {data} = await axios.get(url, {
    headers: {
      'x-apikey': flightAwareKey
    }
  });
  return data;
};

export const getFlightInfoByFaFlightId = async (faFlightId: string) => {
  const url = `https://cors.node.np-platform.com/https://aeroapi.flightaware.com/aeroapi/flights/${faFlightId}`;
  const flightAwareKey = localStorage.getItem('FLIGHTAWARE_API_KEY');
  if (!flightAwareKey) return;
  const {data} = await axios.get(url, {
    headers: {
      'x-apikey': flightAwareKey
    }
  });
  return data;
};

export interface Origin {
  code: string;
  code_icao: string;
  code_iata: string;
  code_lid: any;
  timezone: string;
  name: string;
  city: string;
  airport_info_url: string;
}

export interface FlightAware {
  ident: string;
  ident_icao: string;
  ident_iata: string;
  actual_runway_off: any;
  actual_runway_on: any;
  fa_flight_id: string;
  operator: string;
  operator_icao: string;
  operator_iata: string;
  flight_number: string;
  registration: string;
  atc_ident: any;
  inbound_fa_flight_id: string;
  codeshares: string[];
  codeshares_iata: string[];
  blocked: boolean;
  diverted: boolean;
  cancelled: boolean;
  position_only: boolean;
  origin: Origin;
  destination: Origin;
  departure_delay: number;
  arrival_delay: number;
  filed_ete: number;
  foresight_predictions_available: boolean;
  scheduled_out: string;
  estimated_out: string;
  actual_out: string;
  scheduled_off: string;
  estimated_off: string;
  actual_off: string;
  scheduled_on: string;
  estimated_on: string;
  actual_on: string;
  scheduled_in: string;
  estimated_in: string;
  actual_in: string;
  progress_percent: number;
  status: string;
  aircraft_type: string;
  route_distance: number;
  filed_airspeed: number;
  filed_altitude: any;
  route: any;
  baggage_claim: any;
  seats_cabin_business: number;
  seats_cabin_coach: number;
  seats_cabin_first: number;
  gate_origin: string;
  gate_destination: string;
  terminal_origin: string;
  terminal_destination: string;
  type: string;
}

export interface IFlightAwareAirport {
  airport_code: string;
  alternate_ident: string;
  code_icao: string;
  code_iata: string;
  code_lid: any;
  name: string;
  type: string;
  elevation: number;
  city: string;
  state: string;
  longitude: number;
  latitude: number;
  timezone: string;
  country_code: string;
  wiki_url: string;
  airport_flights_url: string;
  alternatives: string[];
}

export const getFlightDetail = async (flightNumber: string, date: string) => {
  const url = `https://cors.node.np-platform.com/https://aeroapi.flightaware.com/aeroapi/flights/${flightNumber}?start=${date}T00:00:00Z&end=${date}T23:59:59Z`;
  const flightAwareKey = localStorage.getItem('FLIGHTAWARE_API_KEY');
  if (!flightAwareKey) return;
  const {data} = await axios.get(url, {
    headers: {
      'x-apikey': flightAwareKey
    }
  });
  return data?.flights as FlightAware[];
};

export const getFlightDetailByDate = async (
  flightNumber: string,
  startDate: string,
  endDate: string
) => {
  const url = `https://cors.node.np-platform.com/https://aeroapi.flightaware.com/aeroapi/flights/${flightNumber}?start=${startDate}T00:00:00Z&end=${endDate}T23:59:59Z`;
  const flightAwareKey = localStorage.getItem('FLIGHTAWARE_API_KEY');
  if (!flightAwareKey) return;
  const {data} = await axios.get(url, {
    headers: {
      'x-apikey': flightAwareKey
    }
  });
  return data?.flights as FlightAware[];
};

// icao or iata code
export const getFlightDetailByAirportCode = async (airportCode: string) => {
  const url = `https://cors.node.np-platform.com/https://aeroapi.flightaware.com/aeroapi/airports/${airportCode}`;
  const flightAwareKey = localStorage.getItem('FLIGHTAWARE_API_KEY');
  if (!flightAwareKey) return;
  const {data} = await axios.get(url, {
    headers: {
      'x-apikey': flightAwareKey
    }
  });
  return data as IFlightAwareAirport;
};
